import CELL_DATA_TYPES from '../config/cell-types.config';
import { DYNAMIC_COLUMNS_CONFIG } from '../config/module-configs/content-videos.config';

const getDynamicWidth = (fieldName) => {
  let returnVal = '';
  if (fieldName === 'description') {
    returnVal = '35%';
  } else if (fieldName === 'genres') {
    returnVal = '20%';
  } else if (fieldName === 'contract_no') {
    returnVal = '35%';
  }

  return returnVal;
};

const prepareDynamicColumns = (data) => {
  const columns = [
    {
      id: 'title',
      label: 'Title',
      align: 'left',
      dataKey: 'title',
      sortable: true,
      type: CELL_DATA_TYPES.TOOLTIP_TEXT,
      editable: false,
    },
  ];

  data.forEach((item) => {
    if (item.fieldName === 'series_id') {
      columns.push({
        id: 'series_name',
        label: 'Series',
        align: 'left',
        dataKey: 'series_name',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: false,
      });
    } else if (item.fieldName === 'collection_id') {
      columns.push({
        id: 'collection_name',
        label: 'Collection',
        align: 'left',
        dataKey: 'collection_name',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: false,
      });
    } else if (item.fieldName === 'distributor_id') {
      columns.push({
        id: 'distributor_name',
        label: 'Distributor Name',
        align: 'left',
        dataKey: 'distributor_name',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: false,
      });
    } else if (item.fieldName === 'fhNotes') {
      columns.push({
        id: 'fhNotes',
        label: 'Notes',
        align: 'left',
        dataKey: 'fhNotes',
        sortable: false,
        type: CELL_DATA_TYPES.TEXT,
        editable: true,
      });
    } else if (item.fieldName === 'distributorSkuSeries') {
      columns.push({
        id: 'distributorSkuSeries',
        label: 'Distrubutor Series SKU',
        align: 'center',
        dataKey: 'distributorSkuSeries',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: false,
      });
    } else if (item.fieldName === 'videoLanguage') {
      columns.push({
        id: 'video_language',
        label: 'Language',
        align: 'center',
        dataKey: 'video_language',
        sortable: true,
        type: CELL_DATA_TYPES.PNM_CELL,
        editable: true,
      });
    } else if (item.fieldName === 'tvod_enabled') {
      columns.push({
        id: 'tvod_enabled',
        label: 'TVOD License',
        align: 'left',
        dataKey: 'tvod_enabled',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: false,
      });
    } else if (item.fieldName === 'tvod') {
      columns.push({
        id: 'tvod',
        label: 'TVOD Street Date',
        align: 'left',
        dataKey: 'tvod',
        sortable: true,
        type: CELL_DATA_TYPES.DATE,
        editable: true,
      });
    } else if (item.fieldName === 'svod') {
      columns.push({
        id: 'svod',
        label: 'SVOD Street Date',
        align: 'left',
        dataKey: 'svod',
        sortable: true,
        type: CELL_DATA_TYPES.DATE,
        editable: true,
      });
    } else if (item.fieldName === 'avod') {
      columns.push({
        id: 'avod',
        label: 'AVOD Street Date',
        align: 'left',
        dataKey: 'avod',
        sortable: true,
        type: CELL_DATA_TYPES.DATE,
        editable: true,
      });
    } else if (item.fieldName === 'avod_validated') {
      columns.push({
        id: 'avod_validated',
        label: 'AVOD License',
        align: 'center',
        dataKey: 'avod_validated',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: true,
      });
    } else if (item.fieldName === 'svod_enabled') {
      columns.push({
        id: 'svod_enabled',
        label: 'SVOD License',
        align: 'center',
        dataKey: 'svod_enabled',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: false,
      });
    } else if (item.fieldName === 'contract_no') {
      columns.push({
        id: 'contract_no',
        label: 'Contract Number',
        align: 'center',
        dataKey: 'contract_no',
        sortable: true,
        type: CELL_DATA_TYPES.TEXT,
        editable: DYNAMIC_COLUMNS_CONFIG[item.fieldName]?.editable || false,
        width: getDynamicWidth(item.fieldName),
      });
    } else {
      columns.push({
        id: item.fieldName,
        label: item.fieldName
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' '),
        align: 'left',
        dataKey: item.fieldName,
        sortable: true,
        width: getDynamicWidth(item.fieldName),
        type:
          DYNAMIC_COLUMNS_CONFIG[item.fieldName]?.cellType ||
          CELL_DATA_TYPES.TEXT,
        editable: DYNAMIC_COLUMNS_CONFIG[item.fieldName]?.editable || false,
      });
    }
  });

  return columns;
};

export const getEditableCellDefaultValue = (dataKey, cellType) => {
  if (cellType === 'switch') return false;

  const defaultValues = {
    restricted_content: 'NC',
    avod_validated: 'NC',
    restricted_content_reason: 'NA',
    good_bad: 'NA',
    trashy: 'NO',
    country: 'UN',
    ad_timing_status: 'NC',
    public_domain: 'NO',
    poster_16x9_status: 'NC',
    always_published: 'NO',
    video_type: 'FE',
    region: 'UK',
    mpaa_rating: 'NR',
    genre_status: 'NC',
    tvod_iap: '1',
    video_status: 'NC',
    video_status_reason: 'NC',
    trailer_status: 'NC',
    trailer_status_reason: 'NC',
    quality_video: 'NC',
    quality_poster_16x9: 'NC',
    quality_trailer: 'NC',
  };

  if (!defaultValues[dataKey] && cellType === 'selection') return null;

  return defaultValues[dataKey] ?? '';
};

export default prepareDynamicColumns;
